import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a9557156d47130014a9e90e_1788189425080_c973ea61/eduteamboard/src/app/compare/page.tsx");
